module.exports = __webpack_public_path__ + "files/dfdc4a5d617d84c2a4939098f306358a.svg";